<template>
  <base-dialog
    :show="showDialog"
    :show-cancel="$t('common.action.cancel')"
    :action-name="$t('page.account.plan.downgrade')"
    :title="$t('page.account.plan.downgradeTitle')"
    :title-icon="icon"
    :action-link="props.link?.url"
    :is-loading="useAccountStore().subscriptionCancelLinkLoading"
    @close="showDialog = false"
    :max-width="$vuetify.display.mdAndUp ? '50%' : '100%'"
  >
    <template #content>
      <v-row no-gutters class="mx-2 my-5 text-grey-darken-3">
        <v-col>
          <v-row class="text-center">
            <v-card-text class="text-body-1 font-weight-medium">{{
              $t("page.account.plan.downgradeExpect")
            }}</v-card-text>
          </v-row>
          <v-row no-gutters>
            <v-col cols="1" class="pt-4">
              <v-icon icon="mdi-check-circle" color="grey-darken-1" />
            </v-col>
            <v-col>
              <v-card-text class="font-weight-medium pb-0">{{
                $t("page.account.plan.downgradeFeature1")
              }}</v-card-text>
              <v-card-text class="pt-0">{{
                $t("page.account.plan.downgradeFeature1Text")
              }}</v-card-text>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="1" class="pt-4">
              <v-icon icon="mdi-check-circle" color="grey-darken-1" />
            </v-col>
            <v-col>
              <v-card-text class="font-weight-medium pb-0">{{
                $t("page.account.plan.downgradeFeature2")
              }}</v-card-text>
              <v-card-text class="pt-0">{{
                $t("page.account.plan.downgradeFeature2Text")
              }}</v-card-text>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="1" class="pt-4">
              <v-icon icon="mdi-check-circle" color="grey-darken-1" />
            </v-col>
            <v-col>
              <v-card-text class="font-weight-medium pb-0">{{
                $t("page.account.plan.downgradeFeature3")
              }}</v-card-text>
              <v-card-text class="pt-0">{{
                $t("page.account.plan.downgradeFeature3Text")
              }}</v-card-text>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col class="text-center">
              <v-card-text class="py-0 text-caption">{{
                $t("page.account.plan.downgradeMessage")
              }}</v-card-text>
              <v-card-text class="text-body-2 font-weight-medium">{{
                $t("page.account.plan.readyToDowngrade")
              }}</v-card-text>
              <v-card-text class="text-body-2">{{
                $t("page.account.plan.downgradeMessage2")
              }}</v-card-text>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script lang="ts" setup>
import BaseDialog from "@/shared/components/Common/BaseDialog.vue";
import { useAccountStore } from "@/account/stores/account";
import { ref } from "vue";

const showDialog = ref(false);

const props = defineProps({
  link: {
    type: Object,
    default: () => ({}),
  },
});

const open = () => {
  showDialog.value = true;
};

defineExpose({
  open,
});

const icon = "mdi-arrow-down-thick";
</script>
